<template>
  <div>
    <div class="text-center">
      <BaseHeading class="mb-4 text-center" :level="1">{{
        $t('complaintForm.submitComplaint')
      }}</BaseHeading>

      <span>{{ $t('complaintForm.whatShouldBeRepaired') }}</span>
    </div>

    <div :class="$style.cards">
      <v-card
        v-for="(card, index) in cards"
        :key="index"
        :min-height="470"
        class="d-flex flex-column text-center pa-8"
        :class="$style.card"
        outlined
      >
        <div :class="$style.imagewrapper">
          <img
            v-if="card.image.src"
            :class="$style.image"
            :src="card.image.src"
            :alt="card.title"
          />
        </div>

        <v-card-title class="d-flex justify-center py-1 px-0">
          <BaseHeading class="mb-0 text-center" :class="$style.title" :level="2">{{
            card.title
          }}</BaseHeading>
        </v-card-title>

        <v-card-text :class="$style.text" class="body-1 px-0">{{ card.text }}</v-card-text>

        <v-card-actions class="d-flex flex justify-end flex-column pa-0">
          <BaseButton
            v-if="card.cta.primary"
            :href="card.cta.primary.href"
            class="mx-0"
            :class="$style.primary"
            :disabled="!card.cta.primary.href"
            >{{ card.cta.primary.title }}</BaseButton
          >

          <BaseButton
            v-if="card.cta.secondary"
            type="secondary"
            :href="card.cta.secondary.href"
            class="mt-5 mx-0"
            :class="$style.secondary"
            :disabled="!card.cta.primary.href"
            >{{ card.cta.secondary.title }}</BaseButton
          >
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash-es'

import EngineImage from '@/images/complaint_form_engine.png'
import BatteryImage from '@/images/complaint_form_battery.png'
import ComponentsImage from '@/images/complaint_form_components.png'

import { SOURCE_DATA_CONSTANTS } from '@/js/components/Forms/ComplaintForm/_store-module/constants.js'

export const COMPLAINT_FORM_TICKET_SELECT = {
  ID: 'id',
  PID: 'pid',
  TYPE: 'type',
  URL: 'url',
  TICKET_TYPE: SOURCE_DATA_CONSTANTS.TICKET_TYPE,
  TICKET_TYPES: SOURCE_DATA_CONSTANTS.TICKET_TYPES,
}

export default {
  name: 'ComplaintFormTicketSelect',
  props: {
    data: {
      type: String,
      default: '',
    },
  },
  computed: {
    parsedData() {
      try {
        const parsedJSON = JSON.parse(this.data)
        return parsedJSON.reduce(
          (acc, data) => ({
            ...acc,
            [get(data, COMPLAINT_FORM_TICKET_SELECT.TICKET_TYPE, '_')]: data,
          }),
          {},
        )
      } catch {
        return []
      }
    },
    cards() {
      return [
        {
          image: {
            src: EngineImage,
          },
          title: this.$t('complaintForm.engineForm'),
          text: this.$t('complaintForm.engineFormInfo'),
          cta: {
            primary: {
              title: this.$t('complaintForm.submitApplicationForm'),
              href: get(
                this.parsedData,
                [
                  COMPLAINT_FORM_TICKET_SELECT.TICKET_TYPES.ENGINE,
                  COMPLAINT_FORM_TICKET_SELECT.URL,
                ],
                '',
              ),
            },
            secondary: {
              title: this.$t('complaintForm.submitReGreasingApplicationForm'),
              href: get(
                this.parsedData,
                [
                  COMPLAINT_FORM_TICKET_SELECT.TICKET_TYPES.WORKTIME,
                  COMPLAINT_FORM_TICKET_SELECT.URL,
                ],
                '',
              ),
            },
          },
        },
        {
          image: {
            src: BatteryImage,
          },
          title: this.$t('complaintForm.batteryForm'),
          text: this.$t('complaintForm.batteryFormInfo'),
          cta: {
            primary: {
              title: this.$t('complaintForm.submitApplicationForm'),
              href: get(
                this.parsedData,
                [
                  COMPLAINT_FORM_TICKET_SELECT.TICKET_TYPES.BATTERY,
                  COMPLAINT_FORM_TICKET_SELECT.URL,
                ],
                '',
              ),
            },
          },
        },
        {
          image: {
            src: ComponentsImage,
          },
          title: this.$t('complaintForm.componentsForm'),
          text: this.$t('complaintForm.componentsFormInfo'),
          cta: {
            primary: {
              title: this.$t('complaintForm.submitApplicationForm'),
              href: get(
                this.parsedData,
                [
                  COMPLAINT_FORM_TICKET_SELECT.TICKET_TYPES.COMPONENT,
                  COMPLAINT_FORM_TICKET_SELECT.URL,
                ],
                '',
              ),
            },
          },
        },
      ]
    },
  },
}
</script>

<style lang="scss" module>
.cards {
  display: grid;
  grid-gap: 1.875rem;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  justify-items: center;
  margin: 3.75rem 0;
}

.card {
  border-color: var(--primary) !important;
  border-radius: 1.25rem !important;

  transition: var(--transition-primary);

  &:hover {
    box-shadow: 0px 5px 15px 0 hsla(0, 0%, 0%, 0.15);
  }
}

.imagewrapper {
  display: inline-table; // IE11
  flex-shrink: 0; // IE11
}

.image {
  width: 100%;

  border-radius: 0 !important;
}

.title {
  word-break: normal;
}

.text {
  color: var(--black) !important;
  hyphens: auto;
}

.primary {
  padding: 0.75rem 1rem !important;
}

.secondary {
  padding: 0.5rem 1rem !important;
}
</style>
